import React, {Component} from 'react';
import { InputSelectNative } from '../../../commonModules/interface/form-input-inline';
import Dialog from '../../../commonModules/interface/Dialog';

class SubscriptionUpdateForms extends Component {
    state = {
        electricQ: [
            {
                id: "default_electrical_question",
                name: "default_electrical_question"
            }
        ],
        electricR: "default_electrical_question",
        //Photo of the installation
        photo1Q: [
            {
                id: "default_photo_question",
                name: "default_photo_question"
            }
        ],
        photo1R: "default_photo_question",
        solarQ: [
            {
                id: "default_solar_question",
                name: "default_solar_question"
            }
        ],
        solarR: "default_solar_question",
        otherQ: [
            {
                id: "default_otherI_question",
                name: "default_otherI_question"
            }
        ],
        otherR: "default_otherI_question"
    }

    componentDidMount = async() => {
        //Get Actual Schema List
        console.log('[DEBUG], paygoGet All, load schema ');
        let listSchema = [];
        try {
            const response = await fetch('/schema/list', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");
            console.log(resp);
            if (resp.content.lenght == 0) {
                console.log("[ERROR], getting schema getAll response ", resp)
                return;
            }
            //Parse content
            resp.content.map((item) => {
                    // console.log(item);
                    listSchema = listSchema.concat({id: item.id, name: item.name});
                });
            this.setState({
                solarQ: this.state.solarQ.concat(listSchema),
                electricQ: this.state.electricQ.concat(listSchema),
                photo1Q: this.state.photo1Q.concat(listSchema),
                otherQ: this.state.otherQ.concat(listSchema)
            });
        } catch (err) {
            console.log("[ERROR], getting schema getAll data", err)
        }
        console.log("GET USERSCHEMA")
        console.log(this.props)
        try {
            const response = await fetch('/schema/get/userschema?id=' + this.props.subscriptionID + '&type=subscription', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");
            console.log(resp);
            if (resp.content.lenght == 0) {
                console.log("[ERROR], getting schema getAll response ", resp)
                return;
            }
            //Check if value are not empty :
            if (resp.content.q1 !== ""){
                this.setState({solarR:resp.content.q1})
            }
            if (resp.content.q2 !== ""){
                this.setState({electricR:resp.content.q2})
            }
            if (resp.content.q3 !== ""){
                this.setState({photo1R:resp.content.q3})
            }
            if (resp.content.q4 !== ""){
                this.setState({otherR:resp.content.q4})
            }
        } catch (err) {
            console.log("[ERROR], getting schema getAll data", err)
        }

    }
    handleSubmit = async() => {
        //Change FORMS
        console.log("Changement Questionnaire")
        try {
            const response = await fetch('/schema/update/userschema', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({type: "subscription", userID: this.props.subscriptionID, q1: this.state.solarR, q2 :this.state.electricR,q3 : this.state.photo1R, q4: this.state.otherR}),
                credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");
            console.log(resp);
            if (resp.content === "OK") {
                this.props.handleClose()
                return;
            }
            console.log("[ERROR], getting schema getAll response ", resp)

        } catch (err) {
            console.log("[ERROR], getting schema getAll data", err)
        }
    }

    render() {
        console.log("[INFO] ===>> Print Questionnaire !! ")
        return (
            <Dialog
                title="Changement Questionnaire"
                block={true}
                close={this.props.handleClose}
                submitAction={this.handleSubmit}
            >
                <InputSelectNative
                    label="Questionnaire 1"
                    value={this.state.solarR}
                    onChange={e => this.setState({solarR: e.target.value})}
                    options={this.state.solarQ.map( item =>
                        <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                />
                <InputSelectNative
                    label="Questionnaire 2"
                    value={this.state.electricR}
                    onChange={e => this.setState({electricR: e.target.value})}
                    options={this.state.electricQ.map( item =>
                        <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                />
                <InputSelectNative
                    label="Questionnaire 3"
                    value={this.state.photo1R}
                    onChange={e => this.setState({photo1R: e.target.value})}
                    options={this.state.photo1Q.map( item =>
                        <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                />
                <InputSelectNative
                    label="Questionnaire 4"
                    value={this.state.otherR}
                    onChange={e => this.setState({otherR: e.target.value})}
                    options={this.state.otherQ.map( item =>
                        <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                />                    
                {/* <Box p={2}>
                    <Button variant="contained" color="secondary" onClick={this.handleSubmit}>Valider</Button>
                    <Button
                        type="button"
                        onClick={this.props.cancel}>
                        Annuler
                    </Button>
                </Box> */}
            </Dialog>
        );
    }
}

// PayGo Payement MJB - Home600-32
export default SubscriptionUpdateForms;